import { config, loadConfig } from '../../config/environment.js';

type HelpMessageControllerOptions = {
    isWidgetVisible: () => boolean;
    setHelpMessage: (message: string | null) => void;
};

export class WidgetHelpMessageController {
    private helpMessageTimer: ReturnType<typeof setTimeout> | null = null;

    constructor(private readonly options: HelpMessageControllerOptions) { }

    public async offerHelpMessage() {
        await loadConfig();

        const text = config.TOOLTIP.MESSAGE;
        if (!text || !this.options.isWidgetVisible()) {
            return;
        }

        const timeoutMs = config.TOOLTIP.TIMEOUT;

        this.clearHelpMessageTimer();
        this.options.setHelpMessage(text);
        this.helpMessageTimer = setTimeout(() => {
            this.disposeOfferHelpMessage();
        }, timeoutMs);
    }

    public disposeOfferHelpMessage() {
        this.clearHelpMessageTimer();
        this.options.setHelpMessage(null);
    }

    public stop() {
        this.clearHelpMessageTimer();
    }

    private clearHelpMessageTimer() {
        if (this.helpMessageTimer) {
            clearTimeout(this.helpMessageTimer);
            this.helpMessageTimer = null;
        }
    }
}
